// @flow

const routes = {
  '/app/billing': {
    fetch: () =>
      import(
        /* webpackChunkName: 'billing-route' */ 'app/billing/asyncRoute'
      ).then(module => module.default),
  },
  // Not under /app for now asit needs some backend processing that use this specific route
  '/billing': {
    fetch: () =>
      import(
        /* webpackChunkName: 'legacy-billing-route' */ 'app/billing/asyncLegacyRoute'
      ).then(module => module.default),
  },
};

export default routes;
